import { convertDateRangeToEpochTimestamp } from '../../../helpers/utils';
import type { ExportDateRange } from '../types';

export const buildExportTimeRangeParam = (
  exportDateRange: ExportDateRange,
  timezoneOffset: string = '+00:00'
): string => {
  const finalTimeRange = convertDateRangeToEpochTimestamp(
    exportDateRange.dates,
    exportDateRange.timeRange,
    timezoneOffset
  );

  return `${finalTimeRange[0]}:${finalTimeRange[1]}`;
};
